import { render, staticRenderFns } from "./CrowdStakingCard.vue?vue&type=template&id=4b5c3520&scoped=true&"
import script from "./CrowdStakingCard.vue?vue&type=script&lang=js&"
export * from "./CrowdStakingCard.vue?vue&type=script&lang=js&"
import style0 from "./CrowdStakingCard.vue?vue&type=style&index=0&id=4b5c3520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c3520",
  null
  
)

export default component.exports